import { create } from 'zustand';
import { ApiUtils, MiscApi, RequestStrategyEnum } from '@shared/api';

interface IEconomicActivitiesStore {
  loading: boolean;
  error: string | null;
  economicActivities: string[];
  getEconomicActivities: (signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useEconomicActivitiesStore = create<IEconomicActivitiesStore>((set) => ({
  loading: false,
  error: null,
  economicActivities: [],

  getEconomicActivities: ApiUtils.wrapperApi(async (signal?: AbortSignal) => {
    try {
      set({ loading: true, error: null });
      const result = await MiscApi.getEconomicActivities(signal);
      set({ economicActivities: result ?? [], loading: false });
    } catch (error) {
      set({ error: (error as Error).message, loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ economicActivities: [], loading: false, error: null }),
}));
